export const first = (arr: any[]) => arr[0];
